export default class CreateLearningComunityCtrl {

  constructor ($scope, WorkPlanSrv, $mdDialog, $stateParams, $cookies, GlobalConfig, WorkPlanModalSrv, GlobalSrv) {
    var createLearningComunityVM = this
    const currentUser = JSON.parse($cookies.get('currentUser'))
    const texts = GlobalConfig.appTexts
    createLearningComunityVM.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createLearningComunityVM.comboScene = []
    createLearningComunityVM.dataCommunities = []
    createLearningComunityVM.periodsArray = []
    createLearningComunityVM.communitiesArray = []
    createLearningComunityVM.createOrEdit = 'Agregar '
    createLearningComunityVM.textCreateOrEdit = texts.saved
    createLearningComunityVM.createOrEditMV = texts.createDialog
    createLearningComunityVM.communityNameModal = ''
    createLearningComunityVM.selectedTypePeriod = {}
    createLearningComunityVM.periods = []
    createLearningComunityVM.rangeType = GlobalConfig.periods.rangeType
    createLearningComunityVM.range = ''
    createLearningComunityVM.hrefActivityModal = false
    createLearningComunityVM.hoursPlanning = 0
    createLearningComunityVM.isSaveButtonDisabled = false
    createLearningComunityVM.dt_start = $cookies.get('wp_start')
    createLearningComunityVM.dt_end = $cookies.get('wp_end')

    // createLearningComunityVM.idListItem = ''
    createLearningComunityVM.listItemName = ''
    createLearningComunityVM.idWorkPlan = currentUser.workplanId
    createLearningComunityVM.idTeacher = currentUser.teacherId
    const header = {
      teacherId: currentUser.teacherId,
      workplanId: currentUser.workplanId,
      name: currentUser.name
    }
    createLearningComunityVM.startDate = null
    createLearningComunityVM.endDate = null
    createLearningComunityVM.minStartDate = moment().toDate()
    createLearningComunityVM.minEndDate = new Date()
    createLearningComunityVM.searchText = ''
    createLearningComunityVM.isFeedback = currentUser.isFeedback

    // FUNCTIONS
    createLearningComunityVM.hasError = hasError
    createLearningComunityVM.showErrorMessages = showErrorMessages
    createLearningComunityVM.validateForm = validateForm
    createLearningComunityVM.addActivity = addActivity
    createLearningComunityVM.funSelectedPeriod = funSelectedPeriod
    createLearningComunityVM.validateCheklistPeriods = validateCheklistPeriods
    createLearningComunityVM.searchCommunity = searchCommunity
    createLearningComunityVM.changeCommunity = changeCommunity
    createLearningComunityVM.close = close
    createLearningComunityVM.startDateChange = startDateChange
    createLearningComunityVM.changeSearchText = changeSearchText
    createLearningComunityVM.updateRangeType = (val) => {
      createLearningComunityVM.rangeType = val
      createLearningComunityVM.periodsArray = []
      createLearningComunityVM.startDate = null
      createLearningComunityVM.endDate = null
    }
    createLearningComunityVM.updateRangeData = (val) => {
      createLearningComunityVM.periodsArray = val['periods']
      createLearningComunityVM.startDate = val['dates'][0]
      createLearningComunityVM.endDate = val['dates'][1]
    }

    function searchCommunity (searchText) {
      let matcher = new RegExp(searchText, 'i')
      let arr = []
      let attr = 'listItemName'
      createLearningComunityVM.communitiesArray.forEach((searchText) => {
        if (searchText[attr].match(matcher)) {
          arr.push(searchText)
        }
      })
      return arr
    }

    function changeCommunity (community) {
      if (community && community.idListItem) {
        createLearningComunityVM.idListItemChangue = community.idListItem
      } else {
        createLearningComunityVM.idListItemChangue = null
      }
      createLearningComunityVM.listItemName = community.listItemName
    }

    function changeSearchText (searchText) {
      createLearningComunityVM.searchText = searchText.substring(0, 200)
      createLearningComunityVM.listItemName = searchText
      createLearningComunityVM.idListItemChangue = null
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function validateForm (form) {
      return form.$invalid || createLearningComunityVM.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createLearningComunityVM.rangeType == 1 ? createLearningComunityVM.periodsArray.length < 1 : false)
    }

    function getDataFormCommunities () {
      // List Service Committee
      WorkPlanSrv.getDataFormCommunities.get(header).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          createLearningComunityVM.dataCommunities = dataReturn
          createLearningComunityVM.listsAmbit = createLearningComunityVM.dataCommunities.listsAmbit.items
          createLearningComunityVM.periods = createLearningComunityVM.dataCommunities.listPeriods
          createLearningComunityVM.range = createLearningComunityVM.dataCommunities.communities.timeRangeTypeId
          createLearningComunityVM.communitiesArray = createLearningComunityVM.dataCommunities.listsCommunities.items
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    activate()

    function activate () {
      if (createLearningComunityVM.isEditing) {
        createLearningComunityVM.createOrEdit = 'Editar '
        createLearningComunityVM.createOrEditMV = texts.editDialog
        createLearningComunityVM.textCreateOrEdit = texts.modified
        editCommunity()
      }

      getDataFormCommunities()
    }

    function addActivity (sw, isExecution) {
      createLearningComunityVM.isSaveButtonDisabled = true
      createLearningComunityVM.hrefActivityModal = sw
      let origin = 1
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function createJson (origin) {      
      let workplanTeacherActivityId = null
      let idListItem = createLearningComunityVM.idListItemChangue
      createLearningComunityVM.communityNameModal = createLearningComunityVM.listItemName
      let listItemNameCommunity = createLearningComunityVM.listItemName
      if (createLearningComunityVM.isEditing) {
        workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        idListItem = createLearningComunityVM.idListItem
        createLearningComunityVM.communityNameModal = createLearningComunityVM.listItemNameCommunity
        listItemNameCommunity = createLearningComunityVM.listItemNameCommunity
      }

      var community = {
        teacherId: header.teacherId,
        workplanId: header.workplanId,
        name: listItemNameCommunity,
        description: createLearningComunityVM.detail,
        hoursPlanning: createLearningComunityVM.hoursPlanning,
        ambitId: createLearningComunityVM.typeScene,
        communityId: idListItem,
        timeRangeTypeId: createLearningComunityVM.rangeType,
        activityId: GlobalConfig.minorActivityId.learningComunity,
        workplanTeacherActivityId: workplanTeacherActivityId,
        origin: origin,
        isFeedbackActivity: createLearningComunityVM.isFeedback
      }

      if (parseInt(createLearningComunityVM.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createLearningComunityVM.periodsArray) {
          var temp = {
            periodId: createLearningComunityVM.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        community.periods = arrayPeriod
      } else {
        community.startDate = new Date(createLearningComunityVM.startDate)
        community.endDate = new Date(createLearningComunityVM.endDate)
      }
      addOrEditCommunity(community)
    }

    function editCommunity () {
      WorkPlanSrv.getActivityDetailTeachingStaff.get({activityTypeId: parseInt($stateParams.activityTypeId), workplanTeacherActivityId: $stateParams.workplanTeacherActivityId}).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with server')
        }
      }, function (data) {
        console.log(data)
      })
    }

    function setValues (community) {
      createLearningComunityVM.isEditingAutocomplete = true
      createLearningComunityVM.selectedItem = community.listItemNameCommunity
      createLearningComunityVM.idListItem = community.listItemIdCommunity
      createLearningComunityVM.listItemNameCommunity = community.listItemNameCommunity
      createLearningComunityVM.typeScene = community.listItemIdAmbit
      createLearningComunityVM.detail = community.description
      createLearningComunityVM.hoursPlanning = community.hoursPlanned
      createLearningComunityVM.rangeType = community.timeRangeTypeId
      createLearningComunityVM.periodsArray = []
      createLearningComunityVM.selectedTypePeriod = {}

      if (createLearningComunityVM.rangeType == 1) {
        var splits = community.periodId.split(',')
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createLearningComunityVM.periodsArray.push(parseInt(valor))
          createLearningComunityVM.selectedTypePeriod[valor] = true
        }
      }

      let m = moment(community.startDate, 'YYYY-MM-DD')
      createLearningComunityVM.dt_start = m.isValid() ? m.toDate() : null

      m = moment(community.endDate, 'YYYY-MM-DD')
      createLearningComunityVM.dt_end = m.isValid() ? m.toDate() : null

      if (community.startDate) {
        var startDateNew = moment(community.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createLearningComunityVM.minStartDate = moment(community.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createLearningComunityVM.isEditing = true
    }

    function addOrEditCommunity (community) {
      WorkPlanSrv.addActivityCommunity.add(community).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          getSendNotify (community.origin)
          showModalAddCommunity()
        } else {
          createLearningComunityVM.isSaveButtonDisabled = false
          console.log('Comunications problem with server')
        }
      }, function (data) {
        createLearningComunityVM.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function showModalAddCommunity () {
      let header = {
        createOrEdit: createLearningComunityVM.createOrEditMV,
        textCreateOrEdit: createLearningComunityVM.textCreateOrEdit,
        itemName: createLearningComunityVM.communityNameModal,
        nameModal: texts.modalTypeName.learningComunity,
        modalType: texts.modalTypeId.learningComunity
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createLearningComunityVM.periodsArray.includes(period.periodId)) {
          createLearningComunityVM.periodsArray.push(period.periodId)
        }
      } else {
        let index = createLearningComunityVM.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createLearningComunityVM.periodsArray.splice(index, 1)
        }
      }
      createLearningComunityVM.isTouchedPeriods = true
    }

    function close () {
      return $mdDialog.hide()
    }

    function startDateChange () {
      let m = moment(createLearningComunityVM.startDate)
      createLearningComunityVM.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function getSendNotify (origin) {
      let msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva comunidad en la etapa de planeación.'
      if (origin == GlobalConfig.activityTypeId.originActivityExecution) {
        msg = 'El profesor ' + currentUser.dsFullname + ' ha registrado una nueva comunidad en la etapa de ejecución.'
      }
      let data = {
        idTeacher: currentUser.teacherId,
        dsName: 'Notificación, se agregó o editó una comunidad',
        dsDescription: msg,
        idNotification_delivery_type: GlobalConfig.notificationType.inbox,
        is_grouped: 0,
        submodule: GlobalConfig.modules.consolidation
      }
      GlobalSrv.sendNotificationsEvaluatorsSubmodule(data)
    }
  }// FIN DEL CONSTRUCTOR
  rbPlanifications (bool) {
    if (bool) {
      this.startDate = null
      this.endDate = null
    } else {
      this.periodsArray = []
      this.periodsArray = []
      this.selectedTypePeriod = null
      this.startDate = null
      this.endDate = null
    }
  }

  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}

CreateLearningComunityCtrl.$inject = ['$scope', 'WorkPlanSrv', '$mdDialog', '$stateParams', '$cookies', 'GlobalConfig', 'WorkPlanModalSrv', 'GlobalSrv']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/consolidationCP/learningAndPracticeCommunities/create/createLearningComunityCtrl.js